import { InnoTable } from "@InnoUI";

const TableLoader = (props) => {
  const { tableConfig, column } = props;

  return (
    <InnoTable
      tableConfig={tableConfig}
      column={column}
      data={[]}
      loading={true}
    />
  );
};

export default TableLoader;
